import * as z from "zod";
import { isoDate } from "./common";

export const AppPlatform = z.enum(["IOS", "ANDROID"]);
export type AppPlatform = z.output<typeof AppPlatform>;

/**
 * `UPDATE_REQUIRED` blocks the app behind an update screen; `UPDATE_AVAILABLE`
 * is a prompt the user may dismiss.
 */
export const AppUpdateStatus = z.enum(["UP_TO_DATE", "UPDATE_AVAILABLE", "UPDATE_REQUIRED"]);
export type AppUpdateStatus = z.output<typeof AppUpdateStatus>;

export const AppVersionCheck = z.object({
  platform: AppPlatform,
  version: z.string(),
  status: AppUpdateStatus,
  minimumVersion: z.string().nullable(),
  latestVersion: z.string().nullable(),
  storeUrl: z.string().nullable(),
  message: z.string().nullable(),
});
export type AppVersionCheck = z.output<typeof AppVersionCheck>;

export const AppVersionPolicy = z.object({
  platform: AppPlatform,
  minimumVersion: z.string().nullable(),
  latestVersion: z.string().nullable(),
  storeUrl: z.string().nullable(),
  message: z.string().nullable(),
  /** Null for a platform that has never been configured. */
  updatedAt: isoDate.nullable(),
});
export type AppVersionPolicy = z.output<typeof AppVersionPolicy>;

/** The whole policy: a null field is cleared. */
export type AppVersionPolicyInput = Omit<AppVersionPolicy, "platform" | "updatedAt">;
